import { FundDetailsState } from '@/store/fundDetails/typings';

export const initialFundDetailsState: FundDetailsState = {
  name: '',
  isLoading: false,
  fundId: '',
  fundNameId: '',
  shareClassNameId: '',
  fundSize: null,
  fundSizeValueDate: null,
  shareClasses: [],
  selectedShareClass: null,
  selectedShareClassIsin: '',
  assetClassName: '',
  assetClassId: '',
  subAssetClassName: '',
  availableTabs: null,
  fundRangeName: null,
  fundHeroType: 0,
  formJson: '',
  sdrLabel: 0,
  literatureAuthorizations: null,
  isFundDetailsImportantInfoAvailable: false,
  correlationFundRangeID: null,
  isPageAvailable: true,
  isInvestmentTrustDisclaimerAvailable: false,
  literatureTabSelectedSubTab: '',
  cumulativeQuarterlyData: '',
  annualizedQuarterlyData: '',
  managementTabData: [],
  literatureTabData: [],
  derivativeUsageTabData: [],
  keyRiskTabData: [],
  portfolioSecuritiesTabData: [],
  codesTabData: null,
  riskAnalysisTabData: '',
  fundDetailsImportantInformationData: '',
  fundFactsTabData: [],
  fundRiskStatisticsTabData: null,
  cumulativeTabData: null,
  cumulativeDailyTabData: '',
  annualizedTabData: null,
  annualizedDailyTabData: '',
  keyInformationTabData: null,
  holdingsTabData: null,
  discreteTabData: null,
  calendarTabData: '',
  fundsPerformanceDisclaimerData: [],
  fundDetailsDocuments: [],
  breakdownSectorData: '',
  breakdownCountryData: '',
  breakdownCreditProfileData: '',
  breakdownMaturityProfileData: '',
  authorisedCountriesTabData: '',
  tradingInformationTabData: '',
  cumulativeChartData: null,
  filteredCumulativeChartData: null,
  correlationMatrixTabData: '',
  premiumBarChartData: '',
  premiumLineChartData: '',
  podcastTabData: '',
  keyInfoTabManualDisclaimerData: [],
  holdingsTabManualDisclaimerData: [],
  preliminaryImportantInfo: '',
  sfdrClassificationId: '',
};
